import cn from "@utils/cn";
import Icon from "@components/elements/Icon";

const CLASS_NAMES = cn(`
  inline-flex
  items-center
  justify-center
  w-8
  h-8
  ms-auto
  text-lg!
  font-bold
  rounded-full
  border
  border-transparent
  transition-all
  duration-200

  bg-(--primary-background-color)
  text-(--primary-foreground-color)

  hover:brightness-90
  focus:outline-hidden
  active:brightness-85
`);

export default function CloseButton(props) {
  const {
    className,
    ...rest
  } = props;

  return (
    <button
      className={cn(CLASS_NAMES, className)}
      type="reset"
      aria-label="close"
      {...rest}
    >
      <Icon iconName="xmark" />
    </button>
  );
}
